import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>Oops! The page you are looking for doesn't exist or has been moved.</p>
          <div className="not-found-actions">
            <Link to="/" className="home-button">Back to Home</Link>
            <Link to="/products" className="products-button">View Our Products</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
